import { Menu } from "@/types/menu";

const menuData: Menu[] = [
  {
    id: 1,
    title: "Home",
    path: "/",
    newTab: false,
  },
  {
    id: 2,
    title: "About",
    path: "/about",
    newTab: false,
  },
//  {
//    id: 3,
//    title: "Research",
//    path: "/research",
//    newTab: false,
//  },
  {
    id: 4,
    title: "Contact",
    path: "/contact",
    newTab: false,
  },

];
export default menuData;
